import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CATEGORY_TICKET, GET_CATEGORY_TICKET_SUCCESS, GET_CATEGORY_TICKET_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCategoryTicket({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/categories-list`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: GET_CATEGORY_TICKET_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CATEGORY_TICKET_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CATEGORY_TICKET_ERROR, payload: error });
  }
}

export function* watchGetCategoryTicket() {
  yield takeEvery(GET_CATEGORY_TICKET, getCategoryTicket);
}

function* getCategoryTicketSaga() {
  yield all([fork(watchGetCategoryTicket)]);
}

export default getCategoryTicketSaga;
